const addTestName = (prefix = 'test', element: string): string => {
	const polishToEnglish: Record<string, string> = {
		ą: 'a',
		ć: 'c',
		ę: 'e',
		ł: 'l',
		ń: 'n',
		ó: 'o',
		ś: 's',
		ź: 'z',
		ż: 'z',
		Ą: 'A',
		Ć: 'C',
		Ę: 'E',
		Ł: 'L',
		Ń: 'N',
		Ó: 'O',
		Ś: 'S',
		Ź: 'Z',
		Ż: 'Z',
	};

	const preparedElement = element
		.replace(/[ąćęłńóśźżĄĆĘŁŃÓŚŹŻ]/g, (char:string):string => polishToEnglish[char])
		.replace(/\W+/g, ' ')
		.split(/ |\B(?=[A-Z])/)
		.map((word) => word.toLowerCase())
		.join('_');
	return `${prefix}__${preparedElement}`;
};

export { addTestName };
